import { esignUploadLabel } from '@/utils/signedDoc'

function readEsignQuery() {
  try {
    return JSON.parse(sessionStorage.getItem('esignQuery') || '{}')
  } catch (e) {
    return {}
  }
}

/** 电子签署 / 合同图片预览（stepForm） */
const esign = {
  name: 'esign',
  componentTypes: ['navigate', 'stepForm'],
  formParams: {},
  formRules: {},
  formData: () => {
    const q = readEsignQuery()
    return {
      card: q.title || '电子签署',
      bottomButtons: [
        {
          code: 'esignBack',
          name: '返回列表',
          type: '',
          icon: '',
          plain: false,
          round: false,
          style: {}
        },
        {
          code: 'esignUpload',
          name: esignUploadLabel(q.reportCode),
          type: 'primary',
          icon: '',
          plain: false,
          round: false,
          style: {}
        }
      ],
      fields: [
        {
          key: 'esignPreview',
          label: '',
          type: 'esignCompose',
          step: 0
        }
      ]
    }
  }
}

export default esign
